<template>
	<footer id="page-footer" class="bg-gray-dark py-3">
		<b-container>
			<b-row class="d-none d-lg-block">
				<b-col cols="12">
					<hr class="border-gray"/>
				</b-col>
			</b-row>
			<b-row class="align-items-center justify-content-center pt-4 pt-lg-0">
				<b-col cols="auto" class="text-right text-lg-left">
					<a  href="#app"
						v-scroll-to="'#app'"
						title="Gå till toppen"
						class="d-inline-block">
						<img src="../assets/img/lidl_logo_footer.svg" width="80" height="80" class="logo footer" alt="Lidl - Allt annat är olidligt">
					</a>
				</b-col>
				<b-col cols="6" sm="6" md="4" lg="auto">
					<p class="small text-white font-weight-bold m-0">Söker du mer information?</p>
					<p class="small text-white m-0 pt-2">
						<a href="https://lidl.se" target="_blank" class="text-white">Lidl.se</a>
					</p>
					<p class="small text-white m-0 pt-2">
						<a href="mailto:hallbarhet@lidl.se " target="_blank" class="text-white">hallbarhet@lidl.se </a>
					</p>
					<p class="small text-white m-0 pt-lg-2">
						<a href="https://jobb.lidl.se" target="_blank" class="text-white">Jobba hos oss</a>
					</p>
				</b-col>
				<b-col cols="12" lg="auto" class="ml-lg-auto text-center text-lg-right">
					<b-row class="pt-5 pt-lg-0 justify-content-center">
						<b-col cols="auto" class="pr-4 pr-lg-3">
							<a href="https://www.facebook.com/lidlsverige/" target="_blank" class="social-media d-inline-block">
								<img src="../assets/img/icons/facebook.svg" alt="Besök oss på Facebook" width="30" height="30">
							</a>
						</b-col>
						<b-col cols="auto" class="px-4 px-lg-3">
							<a href="https://twitter.com/LidlSve" target="_blank" class="social-media d-inline-block">
								<img src="../assets/img/icons/twitter.svg" alt="Besök oss på Twitter" width="42" height="30">
							</a>
						</b-col>
						<b-col cols="auto" class="px-4 px-lg-3">
							<a href="https://www.youtube.com/user/lidlsve" target="_blank" class="social-media d-inline-block">
								<img src="../assets/img/icons/youtube.svg" alt="Besök oss på YouTube" width="37" height="30">
							</a>
						</b-col>
						<b-col cols="auto" class="px-4 px-lg-3">
							<a href="https://www.instagram.com/lidlsve" target="_blank" class="social-media d-inline-block">
								<img src="../assets/img/icons/instagram.svg" alt="Besök oss på Instagram" width="30" height="30">
							</a>
						</b-col>
						<b-col cols="auto" class="px-4 pl-lg-3">
							<a href="https://www.linkedin.com/company/lidl-sverige-kb" target="_blank" class="social-media d-inline-block">
								<img src="../assets/img/icons/linkedin.svg" alt="Besök oss på LinkedIn" width="32" height="30">
							</a>
						</b-col>
					</b-row>
				</b-col>
			</b-row>
			<b-row class="pt-5 pb-4 pb-lg-3">
				<b-col cols="12" class="text-center">
					<a 	href="#app"
						v-scroll-to="'#app'"
						class="d-inline-block w-20">
						<img 	src="../assets/img/icons/arrow-up.svg"
								class="img-fluid transition-bounce"
								width="100"
								height="66"
								alt="Gå till toppen">
					</a>
				</b-col>
			</b-row>
		</b-container>
	</footer>
</template>
<script>
	export default {
		props: {
			pdfLink: {
				default: null
			},
			pdfLinkShort: {
				default: null
			}
		}
	}
</script>
